import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\MoveWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/MoveWikiItemToItemControlleur.php
* @route '/api/item/{item}/move-wiki-item/{wiki_item_id}'
*/
const MoveWikiItemToItemControlleur = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MoveWikiItemToItemControlleur.url(args, options),
    method: 'post',
})

MoveWikiItemToItemControlleur.definition = {
    methods: ["post"],
    url: '/api/item/{item}/move-wiki-item/{wiki_item_id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\MoveWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/MoveWikiItemToItemControlleur.php
* @route '/api/item/{item}/move-wiki-item/{wiki_item_id}'
*/
MoveWikiItemToItemControlleur.url = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            wiki_item_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        wiki_item_id: args.wiki_item_id,
    }

    return MoveWikiItemToItemControlleur.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{wiki_item_id}', parsedArgs.wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\MoveWikiItemToItemControlleur::__invoke
* @see app/Http/Controllers/Item/MoveWikiItemToItemControlleur.php
* @route '/api/item/{item}/move-wiki-item/{wiki_item_id}'
*/
MoveWikiItemToItemControlleur.post = (args: { item: string | { id: string }, wiki_item_id: string | number } | [item: string | { id: string }, wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MoveWikiItemToItemControlleur.url(args, options),
    method: 'post',
})

export default MoveWikiItemToItemControlleur